import { clsx } from 'clsx';
import type { TaskStage } from '@tailorcast/shared-types';

const stageStyles: Record<TaskStage, string> = {
  created: 'bg-blue-100 text-blue-800',
  clarifying: 'bg-purple-100 text-purple-800',
  diagnosing: 'bg-blue-100 text-blue-800',
  planning: 'bg-blue-100 text-blue-800',
  awaiting_approval: 'bg-yellow-100 text-yellow-800',
  executing: 'bg-indigo-100 text-indigo-800',
  completed: 'bg-green-100 text-green-800',
  failed: 'bg-red-100 text-red-800',
  paused: 'bg-gray-100 text-gray-800',
  revising: 'bg-orange-100 text-orange-800',
  monitoring: 'bg-teal-100 text-teal-800',
};

const stageLabels: Record<TaskStage, string> = {
  created: 'Created',
  clarifying: 'Clarifying',
  diagnosing: 'Scanning',
  planning: 'Planning',
  awaiting_approval: 'Awaiting Approval',
  executing: 'Executing',
  completed: 'Completed',
  failed: 'Failed',
  paused: 'Paused',
  revising: 'Revising',
  monitoring: 'Monitoring',
};

interface TaskStageBadgeProps {
  stage: TaskStage;
}

export function TaskStageBadge({ stage }: TaskStageBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        stageStyles[stage]
      )}
    >
      {stageLabels[stage]}
    </span>
  );
}
